import { useLaunchDarkly } from '../../store/LaunchDarkly';

export const useCartEnabled = () => {
  const launchDarkly = useLaunchDarkly();
  return !!launchDarkly.cart;
};
